import { render, staticRenderFns } from "./zxHeader.vue?vue&type=template&id=03398a3c&scoped=true&"
import script from "./zxHeader.vue?vue&type=script&lang=js&"
export * from "./zxHeader.vue?vue&type=script&lang=js&"
import style0 from "./zxHeader.vue?vue&type=style&index=0&id=03398a3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03398a3c",
  null
  
)

export default component.exports